module.exports = __webpack_public_path__ + "static/paidy-card-1-f3121b7a5ba2b317aa7ee2c0c10bb350.png";